import { fetchLottieData } from '../../utils/lazyLottieData';

export const SERVICES_HERO_LOTTIE = () => import('../../assets/gif/Services.json');

export const SERVICE_DETAIL_HERO_LOTTIE = () =>
  import('../../assets/Services-Details-Page.json');

export function prefetchServicesHeroLottie() {
  return fetchLottieData(SERVICES_HERO_LOTTIE, 'services-hero');
}

export function prefetchServiceDetailHeroLottie() {
  return fetchLottieData(SERVICE_DETAIL_HERO_LOTTIE, 'service-detail-hero');
}
